import React, { useContext } from "react";

import { ButtonProps, Button as MuiButton } from "@mui/material";

import { PageLoadStateContext } from "../trackPageLoadState";

export const Button: React.FunctionComponent<ButtonProps> = props => {
  const pageLoadState = useContext(PageLoadStateContext) ?? { loaded: true };
  return (
    <MuiButton
      {...props}
      disabled={!pageLoadState.loaded ? true : props.disabled}
    >
      {pageLoadState.loaded && props.children}
    </MuiButton>
  );
};
